
<script>
    import linq from 'linq'

    export default {
        name: 'howto',

        data () {
            return {
              isActive: {
                description: false,
                rental_thinking: false,
                shipping_cost: false,
                order_rule: false,
                personal_info_rule: false,
                contact: false,
              }
            }
        },

        props: {

        },

        created () {
        },

        async mounted () {
            this.getQueryString()
        },

        methods: {
            getQueryString() {
                const url = window.location.search;
                let hash  = url.slice(1);
                if(hash) {
                    linq.from(this.isActive)
                      .select(x => {
                        x.value = false
                        return x
                    }).toArray();

                    this.isActive[hash] = true
                }else {
                    this.isActive.description = true
                }

            }
        }
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/Howto.vue